import { lazy } from '@loadable/component';
import { createFileRoute } from '@tanstack/react-router';
import { TextKey } from '@mews-commander/enums';
import { GDProduct } from '@mews-framework/good-data';
import { MewsTeam, RouteType } from '@mews/enums';

const LazyBIDashboard = lazy(async () =>
    import(
        /* webpackChunkName: "businessIntelligence" */ '@mews-commander/business-intelligence/pages/BIDashboard'
    ).then((module) => ({
        default: module.BIDashboard,
    }))
);

const Component = () => <LazyBIDashboard dashboardId={Route.useParams().dashboardId} />;

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/BusinessIntelligence/Dashboard/$dashboardId/'
)({
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('viewSensitiveReports');
    },
    loader: async ({ params: { dashboardId }, context }) => {
        const dashboards = await context.ensureQueryData('goodDataDashboards', 'getAll', {
            product: GDProduct.MewsBI,
        });
        const currentDashboard = dashboards.find((d) => d.identifier === dashboardId);

        return {
            title: () => currentDashboard?.title || TextKey.Dashboard,
        };
    },
    component: Component,
    staticData: {
        owner: MewsTeam.Analytics,
        title: TextKey.Dashboard,
        type: RouteType.Frontend,
    },
});
